import useRequestOptions from "hooks/useRequestOptions";
import { ReactElement } from "react";

interface AxiosWrapperProps {
    children: ReactElement;
}

export const AxiosWrapper = ({ children }: AxiosWrapperProps) => {
    useRequestOptions();

    return children;
};